import React, { Component } from "react";
import { connect } from "react-redux";
import cx from "classnames";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import styles from "./style.module.scss";
import * as actions from "~/store/resource/resourceAction";
import { urlBannerHomeMobile } from "~/utils/manageResource";

class BannerHomeMobile extends Component {
  componentDidMount() {
    this.props.requestBannerList();
  }

  render() {
    const settings = {
      arrows: false,
      infinite: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      autoplay: false,
      autoplaySpeed: 5000,
      fade: true,
      speed: 900,
      cssEase: "cubic-bezier(0.7, 0, 0.3, 1)",
      touchThreshold: 100,
      lazyLoad: true,
      dots: false
    };

    return (
      <div className={cx(styles.slide_mobile)}>
        <Slider {...settings}>
          <div key={0} className={styles.slide_mobile_item}>
            <div className={styles.imgInside}>
              <img src={urlBannerHomeMobile} alt="" />
            </div>
          </div>
        </Slider>
        {/* {loading ? (
          <MDBSpinner className={styles.loading} big />
        ) : (
          <Slider {...settings}>
            {data &&
              data.map((item, index) => (
                <div key={index} className={styles.slide_mobile_item}>
                  <div className={styles.imgInside}>
                    <img src={`${item.image_url}`} alt="" />
                  </div>
                </div>
              ))}
          </Slider>
        )} */}
      </div>
    );
  }
}

const mapStateToProps = state => {
  const {
    // bannerList: { data, loading },
    resource: { dataBannerList, loading }
  } = state;
  return {
    loading,
    // data,
    data: dataBannerList
  };
};

const mapDispatchToProps = dispatch => ({
  requestBannerList: () => {
    dispatch(actions.requestBannerList());
  }
});

export default connect(mapStateToProps, mapDispatchToProps)(BannerHomeMobile);
